export const gtmEventTypes = {
  CLICK_BUTTON: 'ACCESSORY_LIST_CLICK_BUTTON',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_BUTTON]: ({CMSGroupGTM, ctaName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_BUTTON,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${ctaName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/accessory-list-duck.js